export class AvaliacaoFormacao {
    constructor({
        id = null,
        avaliacao = null,
        nome = null,
        descricao = null,
        perguntas = Array(),
        tipoAvaliacao = null,
        situacao = null,
        listTipoAvaliacao = Array(),
        listTiposResposta = Array(),
                    listObrigatoriedade = Array(),
    }) {
        this.id = id;
        this.avaliacao = avaliacao;
        this.nome = nome;
        this.descricao = descricao;
        this.perguntas = perguntas;
        this.tipoAvaliacao = tipoAvaliacao;
        this.situacao = situacao;
        this.listTipoAvaliacao = listTipoAvaliacao;
        this.listTiposResposta = listTiposResposta;
        this.listObrigatoriedade = listObrigatoriedade;

    }

    convertToDateTime(dateString) {
        if (!dateString) return null;

        const [day, month, year] = dateString.split('/');
        return new Date(`${year}-${month}-${day}`);
    }

    static Build() {
        return new AvaliacaoFormacao({
            id: null,
            avaliacao: null,
            nome: null,
            descricao: null,
            perguntas: Array(),
            listTipoAvaliacao: Array(),
            listTiposResposta: Array(),
            listObrigatoriedade: Array(),
            tipoAvaliacao: null,
            situacao: null,
        });
    }

    format() {
        return this;
    }
    formatParaCadastrar() {
        return {
            tipo: this.tipoAvaliacao.tipoAvaliacaoId,
            nome: this.nome,
            descricao: this.descricao,
            perguntas: Array.isArray(this.perguntas)
                ? this.perguntas.map(p => ({
                    id: p.id,
                    pergunta: p.pergunta,
                    tipo: p.tipoResposta?.tipoRespostaId,
                    obrigatoriedade: p.obrigatoriedade?.obrigatoriedade
                }))
                : [],
        };
    }

    formatParaEditar() {
        return {
            id: this.id,
            tipo: this.tipoAvaliacao.tipoAvaliacaoId,
            nome: this.nome,
            descricao: this.descricao,
            perguntas: Array.isArray(this.perguntas)
                ? this.perguntas.map(p => ({
                    id: p.id,
                    pergunta: p.pergunta,
                    tipo: p.tipoResposta?.tipoRespostaId,
                    obrigatoriedade: p.obrigatoriedade?.obrigatoriedade
                }))
                : [],
        };
    }
}